import React, { useState } from "react";
import { SignIn, SignForgotPass } from "./user/pages";

function Login() {
  const [state, setState] = useState("signin");
  const handleChangeState = (value) => {
    setState(value);
  }
  return state === "forgot" ?
    <SignForgotPass handleChangeState={handleChangeState} />
    :
    <SignIn handleChangeState={handleChangeState} />;
}

export default Login;
